import { Injectable } from '@angular/core';
import { DefaultEventsMap } from '@socket.io/component-emitter';
import { KeycloakService } from 'keycloak-angular';
import { Observable, Observer, Subject } from "rxjs";
import { io, Socket } from "socket.io-client";
import { environment } from "../../../environments/environment";
import { AnonymousSubject } from 'rxjs/internal/Subject';

export enum ROOM_NAME {
    SOFTWARE_INSTANCE = "SoftwareInstance",
    CART = "Cart",
    USER = "User"
}

export enum SOCKET_KIND_NOTIFICATION {
    RESOURCE_PARAMETER_NOTIFICATION = "resource_parameter_notification",
    USER_SESSION_DELETED = "user_session_deleted"
}

export interface SocketNotification {
    kind: SOCKET_KIND_NOTIFICATION,
}

export interface SocketUserSessionDeletedNotification {
    resourceId: string;
    companyLabel: string;
    date: Date;
}

export interface SocketResourceParameterNotification {
    resourceId: string,
    resourceReferenceLabel: string,
    parameterName: string,
    parameterValue: any,
    companyLabel: string,
    date: Date
}

@Injectable({
    providedIn: 'root'
})
export class SocketIOService {
    // Our socket connection
    private socket: Socket<DefaultEventsMap, DefaultEventsMap>;
    public subject: AnonymousSubject<any>;
    private observable: Observable<any>;
    private pendingRoomJoins: string[] = [];
    private isConnected: boolean = false;

    constructor(private keycloakService: KeycloakService) {

    }

    connect() {
        if (this.socket) {
            return;
        }

        this.socket = io(environment.api_socketio_endpoint, {
            transports: ["websocket"],
            path: environment.api_socketio_path
        });

        this.socket.on('disconnect', (data) => {
            // TODO: SENTRY ERROR
        });

        this.socket.on('connect', async () => {
            let bearerToken: string = await this.keycloakService.getToken();

            this.socket.emit("auth", bearerToken, (result: any) => {
                if (result?.error) {
                    // TODO: SENTRY ERROR
                } else {
                    this.isConnected = true;
                    this.pendingRoomJoins.forEach(room => {
                        this.joinRoom(room)
                            .then(() => {

                            })
                            .catch((error: any) => {

                            });
                    });

                    this.pendingRoomJoins = [];
                }
            })
        });

        this.observable = new Observable<MessageEvent>(observer => {
            this.socket.onAny((data) => {
                observer.next(JSON.parse(data));
            });
        });

        let observer: Observer<MessageEvent> = {
            next: (data: Object) => {
                this.socket.emit('message', JSON.stringify(data));
            },
            error: (err: any) => {
                throw new Error("Function not implemented");
            },
            complete: () => {
                throw new Error("Function not implemented");
            }
        };

        this.subject = new AnonymousSubject<any>(observer, this.observable);
    }

    /**
     * Join the room
     * 
     * @param roomName  The room name
     */
    public joinRoom(roomName: string): Promise<void> {
        return new Promise((resolve, reject) => {
            if (this.isConnected) {
                this.socket!.emit("joinRoom", roomName, (data: any) => {
                    if (data) {
                        reject(data);
                    } else {
                        resolve();
                    }
                    data ? reject(data) : resolve();
                });
            } else {
                this.pendingRoomJoins.push(roomName);
                resolve();
            }
        });
    }

    public leaveRoom(roomName: string): any {
        this.socket?.emit("leaveRoom", roomName);
    }
}